/**
 * Audit Completion Service
 * Handles audit completion logic and exception detection
 */
import { getExceptionSummary, hasExceptions, areAllExpectedScanned } from './validation.service';
const getExpectedAnimalScanToken = (animal) => animal.rapidTagBarcode || animal.rfidTagId || animal.id;
/**
 * Check completion status
 */
export function checkCompletionStatus(expectedAnimals, scannedAnimals) {
    const isComplete = areAllExpectedScanned(expectedAnimals, scannedAnimals);
    const exceptionSummary = getExceptionSummary(expectedAnimals, scannedAnimals);
    return {
        isComplete,
        hasExceptions: exceptionSummary.hasExceptions,
        missingAnimals: exceptionSummary.missingAnimals,
        unexpectedAnimals: exceptionSummary.unexpectedAnimals,
    };
}
/**
 * Prepare exception data for event publishing
 */
export function prepareExceptionData(expectedAnimals, scannedAnimals, cageNumberMismatch = false) {
    const exceptionSummary = getExceptionSummary(expectedAnimals, scannedAnimals);
    return {
        missingAnimals: exceptionSummary.missingAnimals.map(getExpectedAnimalScanToken),
        unexpectedAnimals: exceptionSummary.unexpectedAnimals.map((a) => a.rapidTagBarcode),
        cageNumberMismatch,
    };
}
/**
 * Determine if exception event should be published
 */
export function shouldPublishExceptionEvent(expectedAnimals, scannedAnimals, cageNumberMismatch = false) {
    if (cageNumberMismatch) {
        return true;
    }
    return hasExceptions(expectedAnimals, scannedAnimals);
}
//# sourceMappingURL=audit-completion.service.js.map